export default __webpack_public_path__ + "assets/dac7cd2e28414c3877538661c3f534bb.jpeg";